"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.StorageAccessible__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "offset",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "length",
                type: "uint256"
            },
        ],
        name: "getStorageAt",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "targetContract",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "calldataPayload",
                type: "bytes"
            },
        ],
        name: "simulateAndRevert",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b50610390806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c80635624b25b1461003b578063b4faba0914610064575b600080fd5b61004e610049366004610124565b610079565b60405161005b9190610146565b60405180910390f35b6100776100723660046101e1565b610101565b005b6060600061008883602061030b565b67ffffffffffffffff8111156100a0576100a06101b2565b6040519080825280601f01601f1916602001820160405280156100ca576020820181803683370190505b50905060005b838110156100f75784810154602080830284010152806100ef81610322565b9150506100d0565b5090505b92915050565b600080825160208401855af480600052503d6020523d600060403e60403d016000fd5b6000806040838503121561013757600080fd5b50508035926020909101359150565b600060208083528351808285015260005b8181101561017357858101830151858201604001528201610157565b5060006040828601015260407fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0601f8301168501019250505092915050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b600080604083850312156101f457600080fd5b823573ffffffffffffffffffffffffffffffffffffffff8116811461021857600080fd5b9150602083013567ffffffffffffffff8082111561023557600080fd5b818501915085601f83011261024957600080fd5b81358181111561025b5761025b6101b2565b604051601f82017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0908116603f011681019083821181831017156102a1576102a16101b2565b816040528281528860208487010111156102ba57600080fd5b8260208601602083013760006020848301015280955050505050509250929050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b80820281158282048414176100fb576100fb6102dc565b60007fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff8203610353576103536102dc565b506001019056fea2646970667358221220fa6ea41ff2ff49d8aa39355a26c642c3ea8ee3fca2d732f910567decf0b8d0e464736f6c63430008110033";
var isSuperArgs = function (xs) { return xs.length > 1; };
var StorageAccessible__factory = /** @class */ (function (_super) {
    __extends(StorageAccessible__factory, _super);
    function StorageAccessible__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    StorageAccessible__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    StorageAccessible__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    StorageAccessible__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    StorageAccessible__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    StorageAccessible__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    StorageAccessible__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    StorageAccessible__factory.bytecode = _bytecode;
    StorageAccessible__factory.abi = _abi;
    return StorageAccessible__factory;
}(ethers_1.ContractFactory));
exports.StorageAccessible__factory = StorageAccessible__factory;
